import script from "./DocumentLegal.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentLegal.vue?vue&type=script&setup=true&lang=ts"

import "./DocumentLegal.vue?vue&type=style&index=0&id=8b0b735c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b0b735c"]])

export default __exports__